<template>
  <div class="group-index-item" @click="jumpDetails">
    <div class="group-index-title">
      <div class="left">预警名称：{{formData.warningName}}</div>
      <div class="right">{{formData.warningLevel}}级预警</div>
    </div>
    <div class="user-details-info">
      <p>预警时间：{{formData.warningTime}}</p>
      <p class="b">
        超时时间：{{formData.morethanTime}}
      </p>
      <p class="c" v-show="formData.lastTime">
        距离升级二级预警时间：
        {{formData.lastTime}}
      </p>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {};
  },
  props: {
    navTitle: {
      default: "待处理预警工单",
      type: String,
    },
    formData:{
      default:function(){
        return {}
      },
      type:Object
    },
    jumpOrder:{
      default: false,
      type: Boolean,
    }
  },
  methods: {
    jumpDetails() {
      if(this.jumpOrder){
        if (this.formData.subOrderId && this.formData.jump) {
          utils.jumpToNewPage({
            url:
              window.location.origin +
              "/h5user/beesOrderDetail?subId=" +
              this.formData.subOrderId,
            noTitle: "0",
          });
      }
      }else{
        this.$router.push({
          path:'/warningmanagedetails',
          query:{id:this.formData.id}
        })
        // utils.jumpToNewPage({
        //   url: window.location.origin + "/h5user/warningmanagedetails?id="+this.formData.id,
        //   noTitle: "1",
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.group-index-item {
  background-color: #fff;
  margin: 20px;
  .group-index-title {
    font-size: 24px;
    color: #333;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    height: 79px;
    padding: 0 30px;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
    }
    .right {
      align-items: center;
      display: flex;
      color: red;
      text-align: right;
      img {
        width: 44px;
        height: 44px;
        object-fit: cover;
      }
    }
  }
  .user-details-info {
    padding: 20px ;
    color: #999;
    font-size: 24px;
    p {
      padding-top: 10px;
    }
    .b {
      b {
        color: #f8a651;
      }
    }
    .c {
      b {
        color: #ed3939;
      }
    }
  }
}
</style>